import { type ReactNode } from 'react';
import { CompositeViewConfig } from '../../../types';
import { CompositeViewContext } from './useCompositeViewCtx';

interface CompositeViewProviderProps {
  selectedSym: string;
  isSynthOI: boolean;
  config: CompositeViewConfig;
  onConfigChange: (patch: Partial<CompositeViewConfig>) => void;
  children: ReactNode;
}

export const CompositeViewProvider = ({
  selectedSym,
  isSynthOI,
  config,
  onConfigChange,
  children,
}: CompositeViewProviderProps) => {
  return (
    <CompositeViewContext.Provider
      value={{
        selectedSym,
        isSynthOI,
        config,
        updateConfig: onConfigChange,
      }}
    >
      {children}
    </CompositeViewContext.Provider>
  );
};
